import {createSlice} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";
import {favoriteEventSuccess} from "store/reducer/event/favorite/reducer";
import {likeEventFailure, likeEventStart} from "store/reducer/event/like/reducer";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    event: null
}
const slice = createSlice({
    name: "singleEvent",
    initialState,
    reducers: {
        startSingleEvent: (state) => {
            state.event = null;
            state.status = ReducerStatuses.LOADING;
        },
        errorSingleEvent: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        successSingleEvent: (state, {payload}) => {
            state.status = ReducerStatuses.SUCCESS;
            state.event = payload;
        }
    },
    extraReducers: {
        [favoriteEventSuccess]: (state, {payload}) => {
            if(!!state.event && state.event.id === payload.id) {
                state.event.favorite = payload.favorite;
            }
        },
        [likeEventStart]: (state) => {
            state.event.like = !state.event.like;
            const total = state.event.likes.total;
            state.event.likes.total = state.event.like ? total + 1 : total - 1;
        },
        [likeEventFailure]: (state) => {
            state.event.like = !state.event.like;
            const total = state.event.likes.total;
            state.event.likes.total = state.event.like ? total + 1 : total - 1;
        }
    }
});

const {reducer, actions} = slice;
export const {
    startSingleEvent, errorSingleEvent, successSingleEvent
} = actions;
export default reducer;